import { Link } from 'react-router-dom';
import { useConfiguration } from '@gov-nx/core/service/configuration/useConfiguration';
import { useLocale } from '@gov-nx/core/service/translations/useLocale';
import { useDataBoxMessageFormContext } from '@gov-nx/module/data-box/providers/MessageFormContext';
import { PageCode } from '@gov-nx/module/page/definitions/codes';
import { Button } from '@gov-nx/ui/web/Button/Button';
import { Dialog } from '@gov-nx/ui/web/Dialog';
import { Icon } from '@gov-nx/ui/web/Icon/Icon';

export const LowCreditPrompt = () => {
	const { t: tn } = useLocale(PageCode['datove-schranky']);

	const { lowCreditPrompt, messagePrice } = useDataBoxMessageFormContext();
	const { datovaSchrankaDobitiKredituUrl } = useConfiguration();

	return (
		<Dialog
			isOpen={lowCreditPrompt.isOpen}
			onClose={lowCreditPrompt.handleClose}
			title={<h3>{tn('nova-zprava.je-potreba-dobit-kredit')}</h3>}
			footer={
				<>
					<Button
						color="primary"
						nativeType="button"
						type="base"
						size="m"
						onClick={lowCreditPrompt.handleClose}
						aria-label={tn('kredit.wcag.zrusit')}>
						{tn('nova-zprava.nepridavat-adresata')}
					</Button>
					<Button
						asChild
						color="primary"
						type="solid"
						size="m"
						iconStart={
							<Icon
								type="components"
								name="box-arrow-up-right"
							/>
						}
						aria-label={tn('kredit.wcag.prejit')}>
						<Link
							to={datovaSchrankaDobitiKredituUrl.replace(
								'{{DS_ID}}',
								lowCreditPrompt.senderId as string
							)}
							target="_blank">
							{tn('nova-zprava.prejit-na-dobiti')}
						</Link>
					</Button>
				</>
			}>
			<p>
				{tn('nova-zprava.je-potreba-dobit-kredit-vysvetleni', {
					price: messagePrice.formattedPrice,
				})}
			</p>
		</Dialog>
	);
};
